export default "__VITE_ASSET__6289ae3f__"